"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var validation_fail_1 = require("./validation-fail");
var validation_result_type_1 = require("./validation-result-type");
var Result = /** @class */ (function () {
    function Result() {
    }
    Result.Pass = { type: validation_result_type_1.ValidationResultType.Pass };
    Result.Stop = { type: validation_result_type_1.ValidationResultType.Stop };
    Result.Fail = function (message) { return new validation_fail_1.ValidationFail(message); };
    return Result;
}());
exports.Result = Result;
